<template>
  <div class="block-plan-drawer">
    <div class="block-plan-drawer__options">
      <np-action-btn @click="$parent.$emit('selectedTool', tools.find(({id}) => id === 'tool-blockPlan-crossDock'))">
        Add Cross Dock
      </np-action-btn>
      <np-action-btn @click="$parent.$emit('selectedTool', tools.find(({id}) => id === 'tool-blockPlan-singleLoad'))">
        Add Single Load
      </np-action-btn>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BlockPlanDrawer',
  props: {
    tools: {
      type: Array,
      default: () => [],
    },
  },
};
</script>

<style scoped lang="scss">
.block-plan-drawer {
  padding: 10px;

  &__options {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
  }
}
</style>
